<template>
  <div>
    <form role="form" autocomplete="nope">
      <div class="flex flex-col sm:flex-row gap-4 mb-3">
        <div class="flex items-center gap-4 w-full mb-3">
          <vs-switch
            nome="__veiculoZero123"
            id="_veiculoZero321"
            color="success"
            v-model="form.isCarroZero"
            class="w-15"
            :disabled="form.somenteAgregado"
          >
            <span slot="on"></span>
            <span slot="off"></span>
          </vs-switch>
          <span class="label-switch">Veículo zero</span>
        </div>

        <div v-if="verificaEmpresa()" class="items-center gap-4 w-full mb-3">
          <div style="display: flex; gap: 10px">
            <vs-switch
              name="onlyAgregatte"
              id="onlyAgregatte"
              color="success"
              v-model="form.somenteAgregado"
              class="w-15"
              @change="form.isCarroZero = false"
            >
              <span slot="on"></span>
              <span slot="off"></span>
            </vs-switch>
            <span class="label-switch"
              >Proposta para {{ $t('Agregado', { msg: 'Agregado' }) }}</span
            >
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div
          :class="`vx-col w-full  ${
            isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
          }  mb-2`"
        >
          <vs-input
            class="w-full"
            label="Nome e Sobrenome"
            v-model="form.nome"
            name="Nome"
            id="Nome"
            v-validate="{ required: true }"
            :state="validateState('Nome')"
            :class="validateClass('Nome')"
          />
        </div>

        <div
          v-if="isInterno"
          :class="`vx-col w-full  ${
            isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
          }  mb-2`"
        >
          <vs-input
            class="w-full"
            label="E-mail"
            v-model="form.email"
            name="Email"
            v-validate="{ email: true }"
            :state="validateState('Email')"
            :class="validateClass('Email')"
          />
        </div>

        <div
          :class="`vx-col ${
            isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
          } w-full mb-2`"
        >
          <label for="Celular" class="vs-select--label">Celular</label>
          <the-mask
            mask="(##) #####-####"
            id="Celular"
            class="vs-inputx vs-input--input normal hasValue w-full"
            v-model="form.celular"
            name="Celular"
            :masked="true"
            v-validate="{ required: true, min: 15 }"
            :state="validateState('Celular')"
            :class="validateClass('Celular')"
          />
        </div>
        <div v-if="isInterno" class="vx-col sm:w-1/4 w-full mb-2">
          <label for="Telefone" class="vs-select--label">
            {{ nomenclatura120 ? 'Fixo' : 'Telefone' }}
          </label>
          <the-mask
            mask="(##) ####-####"
            id="Telefone"
            class="vs-inputx vs-input--input normal hasValue w-full"
            v-model="form.telefone"
            name="Telefone"
            :masked="true"
            v-validate="{ min: 14 }"
            :state="validateState('Telefone')"
            :class="validateClass('Telefone')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/3 mb-2">
          <label for="Tipos de Proposta" class="vs-select--label"
            >Tipo de proposta</label
          >
          <v-select
            :options="seletorTiposProposta"
            name="Tipos de Proposta"
            id="Tipos de Proposta"
            v-model="form.tipoProposta"
            :state="validateState('Tipos de Proposta')"
            :class="validateClass('Tipos de Proposta')"
            v-validate="{ required: true }"
          ></v-select>
        </div>

        <div class="vx-col w-full sm:w-1/3 mb-2">
          <label for="Estado" class="vs-select--label">Estado</label>
          <v-select
            :options="estados"
            name="Estado"
            id="Estado"
            autocomplete="off"
            @input="
              buscaDadosSelectsCidades(
                'domMunicipio',
                'cidades',
                'nomeCidade',
                'idCidade',
              ),
                selecionaEstado()
            "
            v-model="estado"
            v-validate="{ required: true }"
            label="label"
            :state="validateState('Estado')"
            :class="validateClass('Estado')"
          ></v-select>
        </div>

        <div class="vx-col w-full sm:w-1/3 mb-2">
          <label for="Cidade" class="vs-select--label">Cidade</label>
          <v-select
            :options="cidades"
            name="Cidade"
            id="Cidade"
            @input="selecionaCidade()"
            v-model="cidade"
            v-validate="{ required: true }"
            label="label"
            :state="validateState('Cidade')"
            :class="validateClass('Cidade')"
          ></v-select>
        </div>
      </div>

      <div
        class="flex flex-col sm:flex-row gap-4 mt-4 w-full"
        v-if="isInterno == true"
      >
        <div class="flex items-center gap-4 w-full mb-6">
          <vs-switch
            color="success"
            v-model="form.permiteInvoiceSelfService"
            class="w-15"
          >
            <span slot="on"></span>
            <span slot="off"></span>
          </vs-switch>
          <span>Opcionais disponíveis para edição do beneficiário.</span>
        </div>

        <div class="flex items-center gap-4 w-full mb-6">
          <vs-switch
            color="success"
            v-model="form.exibirValoresVeiculoNaProposta"
            class="w-15"
          >
            <span slot="on"></span>
            <span slot="off"></span>
          </vs-switch>
          <span>Exibir valores FIPE e de cobertura na proposta.</span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import services from '../../../../../services';
import functions from '../../../../../utils/functions';
import { decryptData } from '../../../../../services/decryptData';

export default {
  props: {
    dadosBeneficiario: Object,
    mascaras: Object,
  },
  components: {
    'v-select': vSelect,
  },
  name: 'dadosGeral',
  data() {
    return {
      desabilitarInputVeiculoZero: false,
      idEmpresa: null,
      form: {
        nome: '',
        email: '',
        celular: '',
        telefone: '',
        tipoProposta: null,
        estado: null,
        cidade: null,
        permiteInvoiceSelfService: false,
        exibirValoresVeiculoNaProposta: false,
        isCarroZero: false,
        somenteAgregado: false,
      },
      isInterno: true,
      codigoSituacaoPlaca: '0',
      tiposProposta: ['Contratação', 'Inclusão'],
      tiposPropostaReduzidos: ['Reativação', 'Troca de Titularidade'],
      estados: [],
      estado: null,
      cidades: [],
      cidade: null,
      nomenclatura120: false,
    };
  },
  watch: {
    async codigoSituacaoPlaca(newValue) {
      this.btnDisabled2 = newValue === 999;
    },
  },
  methods: {
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
    async buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        this[array] = [];
        this.cidade = null;
        return;
      }

      this.$vs.loading();

      if (this.estado && this.estado.id) {
        try {
          const res = await services.getAll(
            'g',
            {},
            `${model}/list/codUf/${this.estado.id}`,
          );
          if (res) {
            res.data = decryptData(res.data);
            this[array] = res.data.map((element) => ({
              id: element[campoPK],
              label: element[campoDescricao],
            }));
          }
        } catch (error) {
          console.error('Erro ao buscar dados: ', error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    selecionaEstado() {
      this.cidade = null;
      this.form.cidade = null;

      const aux = this.estados.find((x) => x.id == this.estado.id);
      this.form.estado = aux ? aux.label : null;
    },
    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      const aux = this.cidades.find((x) => x.id == this.cidade.id);
      this.form.cidade = aux ? aux.label : null;
    },
    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      try {
        let res = await services.getAll('g', {}, `${model}/list/`);
        res.data = decryptData(res.data);
        const dadosFormatados = res.data
          .map((element) => ({
            id: element[campoPK],
            label: element[campoDescricao],
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this[array] = [...dadosFormatados];
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    },
    preencherFormulario(dados) {
      this.form.nome = dados.nome || '';
      this.form.email = dados.email || '';
      this.form.celular = dados.celular || '';
      this.form.telefone = dados.telefone || '';
      this.form.tipoProposta = dados.tipoProposta || null;
      this.form.estado = dados.estado || null;
      this.form.cidade = dados.cidade || null;
      this.form.permiteInvoiceSelfService =
        dados.permiteInvoiceSelfService || false;
      this.form.exibirValoresVeiculoNaProposta =
        dados.exibirValoresVeiculoNaProposta || false;
      this.form.isCarroZero = dados.isCarroZero || false;
      this.form.somenteAgregado = dados.somenteAgregado || false;
      this.cidade = dados.cidade;
      this.estado = dados.estado;
      this.idEmpresa = dados.idEmpresa;
    },
    validateState(ref) {
      return this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
        ? !this.veeErrors.has(ref)
        : null;
    },
    validateClass(ref) {
      return this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
        ? this.veeErrors.has(ref)
        : null;
    },
    validateAll() {
      const requiredFields = [
        'nome',
        'email',
        'celular',
        'tipoProposta',
        'estado',
        'cidade',
      ];

      for (const field of requiredFields) {
        if (!this.form[field]) {
          this.notify(
            'Erro de Validação',
            `O campo ${field} é obrigatório.`,
            'danger',
          );
          return false;
        }
      }

      if (!this.isValidEmail(this.form.email)) {
        this.notify(
          'Erro de Validação',
          'O campo Email deve ser um endereço de email válido.',
          'danger',
        );
        return false;
      }

      const celularNumeros = this.form.celular.replace(/\D/g, '');
      if (celularNumeros.length !== 11) {
        this.notify(
          'Erro de Validação',
          'O campo Celular deve ter 11 dígitos.',
          'danger',
        );
        return false;
      }

      return true;
    },
    isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },

    verificaCelular(telefone) {
      telefone = telefone.replace(/\D/g, '');
      const regexSequencial = /(\d)\1{8}/;
      if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

      if (telefone.length === 11 && parseInt(telefone.substring(2, 3)) !== 9) {
        this.notify(
          'Erro de Validação',
          'Digite um número de celular válido',
          'warning',
        );
        return false;
      }

      for (let n = 0; n < 10; n++) {
        if (
          telefone === new Array(11).join(n) ||
          telefone === new Array(12).join(n)
        ) {
          this.notify(
            'Erro de Validação',
            'Digite um número de celular válido',
            'warning',
          );
          return false;
        }
      }
      const codigosDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
      ];
      if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) === -1) {
        this.notify(
          'Erro de Validação',
          'Digite um número de celular válido',
          'warning',
        );
        return false;
      }
      if (
        telefone.length === 10 &&
        [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) === -1
      ) {
        this.notify(
          'Erro de Validação',
          'Digite um número de celular válido',
          'warning',
        );
        return false;
      }
      if (regexSequencial.test(telefone)) {
        this.notify(
          'Erro de Validação',
          'Digite um número de celular válido',
          'warning',
        );
        return false;
      }
      if (this.dadosConsultor || this.consultorCelular) {
        let celularConsultor = '';
        let celularConsultor2 = '';
        this.dadosConsultor
          ? (celularConsultor = this.dadosConsultor.celular.replace(/\D/g, ''))
          : '';
        this.consultorCelular
          ? (celularConsultor2 = this.consultorCelular.replace(/\D/g, ''))
          : '';
        if (telefone == (celularConsultor || celularConsultor2)) {
          this.notify(
            'Erro de Validação',
            'Digite um número de celular diferente do consultor.',
            'danger',
          );
          return false;
        }
      }
      return true;
    },

    onSubmit() {
      if (this.form.celular) {
        const validateCompleto = this.verificaCelular(this.form.celular);
        if (!validateCompleto) {
          return;
        }
      }

      if (this.form.tipoProposta === 'Contratação') {
        this.form.tipoProposta = 'Adesão';
      }

      if (this.validateAll()) {
        this.$emit('submitDadosBeneficiario', this.form);
        return true;
      }
      return false;
    },
    notify(title, text, color) {
      this.$vs.notify({
        position: 'top-center',
        title: title,
        text: text,
        color: color,
      });
    },
  },
  computed: {
    seletorTiposProposta() {
      return this.codigoSituacaoPlaca === '998'
        ? this.tiposPropostaReduzidos
        : this.tiposProposta;
    },
  },
  async mounted() {
    await this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.preencherFormulario(this.dadosBeneficiario);
    if (this.idEmpresa === 120) {
      this.nomenclatura120 = true;
    }
  },
};
</script>
<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;
    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;
      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}
.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}
body {
  background-color: white;
}
.valorprod {
  color: #000;
  font-weight: bolder;
  font-family: 'roboto';
}
.con-slot-label {
  width: 100%;
  margin-left: 10px;
}
.semPadding {
  padding: 0em 0em 0em 0em !important;
}
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}
.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}
.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}
.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}
#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}
.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}
.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 10px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}
</style>
<style lang="scss" scoped>
.itemprodutos {
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  padding: 10px 0 10px;
}

.title-item-veiculo {
  border-bottom: 1px solid #000;
}
</style>
